var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZipFile = function SvgZipFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#84BD5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3631 30.0035C9.73306 30.0035 9.48306 29.3948 9.84306 28.9648L13.4018 24.2373H10.4518C9.58306 24.2373 9.65306 23.0098 10.4518 23.0098H14.4806C15.2393 23.0098 15.4593 23.7273 14.9206 24.3085L11.5118 28.7348H14.7606C15.5606 28.7348 15.6606 30.0048 14.6818 30.0048H10.3631V30.0035Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5669 23.6868C16.5669 22.8668 17.8869 22.8368 17.8869 23.6868V29.3931C17.8869 30.2218 16.5669 30.2431 16.5669 29.3931V23.6868Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6577 23.6861C19.6577 23.3561 19.9177 22.9961 20.3377 22.9961H22.6465C23.9465 22.9961 25.1165 23.8661 25.1165 25.5336C25.1165 27.1136 23.9465 27.9936 22.6465 27.9936H20.9777V29.3136C20.9777 29.7536 20.6977 30.0023 20.3377 30.0023C20.0077 30.0023 19.6577 29.7536 19.6577 29.3136V23.6861ZM20.9765 24.2548V26.7448H22.6452C23.3152 26.7448 23.8452 26.1536 23.8452 25.5336C23.8452 24.8348 23.3152 24.2548 22.6452 24.2548H20.9765Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
};
export default SvgZipFile;